export default {
  state: {
    marks: [],
    sets: [],
    selectedMark: null,
  },
  getters: {
    getMarks: (state) => state.marks,
    getSets: (state) => state.sets,
    getSelectedMark: (state) => state.selectedMark,
  },
  mutations: {
    setSets(state, payload) {
      state.sets = payload;
    },
    setSelectedMark(state, payload) {
      state.selectedMark = payload;
    },
  },
};
